import { render } from "./RetentionDashboard.vue?vue&type=template&id=0e4b3d48&scoped=true"
import script from "./RetentionDashboard.js?vue&type=script&lang=js"
export * from "./RetentionDashboard.js?vue&type=script&lang=js"

import "./RetentionDashboard.vue?vue&type=style&index=0&id=0e4b3d48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4b3d48"]])

export default __exports__